<template>
  <div class="settlement-table">
    <div v-for="(item, index) in list" class="month" :key="item.month">
      <div class="title">{{ item.month }}</div>
      <el-table :data="item.periods" :table-key="index" size="mini" style="width: 100%" stripe>
        <el-table-column prop="week" label="中国期次" width="80" />
        <el-table-column prop="week" label="起止日期" header-align="center">
          <template slot-scope="{row}">
            <span>{{ row.start }} ~ {{ row.end }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SettlementPeriods',
  data() {
    return {
      year: 2026,
      list: [
        {
          month: '1月',
          periods: [
            { week: '202601', start: '2026-01-07', end: '2026-01-13' },
            { week: '202602', start: '2026-01-14', end: '2026-01-20' },
            { week: '202603', start: '2026-01-21', end: '2026-01-27' },
            { week: '202604', start: '2026-01-28', end: '2026-02-03' }
          ]
        },
        {
          month: '2月',
          periods: [
            { week: '202605', start: '2026-02-04', end: '2026-02-10' },
            { week: '202606', start: '2026-02-11', end: '2026-02-17' },
            { week: '202607', start: '2026-02-18', end: '2026-02-24' },
            { week: '202608', start: '2026-02-25', end: '2026-03-03' }
          ]
        },
        {
          month: '3月',
          periods: [
            { week: '202609', start: '2026-03-04', end: '2026-03-10' },
            { week: '202610', start: '2026-03-11', end: '2026-03-17' },
            { week: '202611', start: '2026-03-18', end: '2026-03-24' },
            { week: '202612', start: '2026-03-25', end: '2026-03-31' }
          ]
        },
        {
          month: '4月',
          periods: [
            { week: '202613', start: '2026-04-01', end: '2026-04-07' },
            { week: '202614', start: '2026-04-08', end: '2026-04-14' },
            { week: '202615', start: '2026-04-15', end: '2026-04-21' },
            { week: '202616', start: '2026-04-22', end: '2026-04-28' },
            { week: '202617', start: '2026-04-29', end: '2026-05-05' }
          ]
        },
        {
          month: '5月',
          periods: [
            { week: '202618', start: '2026-05-06', end: '2026-05-12' },
            { week: '202619', start: '2026-05-13', end: '2026-05-19' },
            { week: '202620', start: '2026-05-20', end: '2026-05-26' },
            { week: '202621', start: '2026-05-27', end: '2026-06-02' }
          ]
        },
        {
          month: '6月',
          periods: [
            { week: '202622', start: '2026-06-03', end: '2026-06-09' },
            { week: '202623', start: '2026-06-10', end: '2026-06-16' },
            { week: '202624', start: '2026-06-17', end: '2026-06-23' },
            { week: '202625', start: '2026-06-24', end: '2026-06-30' }
          ]
        },
        {
          month: '7月',
          periods: [
            { week: '202626', start: '2026-07-01', end: '2026-07-07' },
            { week: '202627', start: '2026-07-08', end: '2026-07-14' },
            { week: '202628', start: '2026-07-15', end: '2026-07-21' },
            { week: '202629', start: '2026-07-22', end: '2026-07-28' },
            { week: '202630', start: '2026-07-29', end: '2026-08-04' }
          ]
        },
        {
          month: '8月',
          periods: [
            { week: '202631', start: '2026-08-05', end: '2026-08-11' },
            { week: '202632', start: '2026-08-12', end: '2026-08-18' },
            { week: '202633', start: '2026-08-19', end: '2026-08-25' },
            { week: '202634', start: '2026-08-26', end: '2026-09-01' }
          ]
        },
        {
          month: '9月',
          periods: [
            { week: '202635', start: '2026-09-02', end: '2026-09-08' },
            { week: '202636', start: '2026-09-09', end: '2026-09-15' },
            { week: '202637', start: '2026-09-16', end: '2026-09-22' },
            { week: '202638', start: '2026-09-23', end: '2026-09-29' },
            { week: '202639', start: '2026-09-30', end: '2026-10-06' }
          ]
        },
        {
          month: '10月',
          periods: [
            { week: '202640', start: '2026-10-07', end: '2026-10-13' },
            { week: '202641', start: '2026-10-14', end: '2026-10-20' },
            { week: '202642', start: '2026-10-21', end: '2026-10-27' },
            { week: '202643', start: '2026-10-28', end: '2026-11-03' }
          ]
        },
        {
          month: '11月',
          periods: [
            { week: '202644', start: '2026-11-04', end: '2026-11-10' },
            { week: '202645', start: '2026-11-11', end: '2026-11-17' },
            { week: '202646', start: '2026-11-18', end: '2026-11-24' },
            { week: '202647', start: '2026-11-25', end: '2026-12-01' }
          ]
        },
        {
          month: '12月',
          periods: [
            { week: '202648', start: '2026-12-02', end: '2026-12-08' },
            { week: '202649', start: '2026-12-09', end: '2026-12-15' },
            { week: '202650', start: '2026-12-16', end: '2026-12-22' },
            { week: '202651', start: '2026-12-23', end: '2026-12-29' },
            { week: '202652', start: '2026-12-30', end: '2027-01-05' }
          ]
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.settlement-table {
  display: flex;
  flex-wrap: wrap;

  .month {
    width: calc(33% - 20px);
    padding: 0 10px;

    .title {
      height: 40px;
      line-height: 40px;
      background-color: #3e4f6a;
      color: #FFFFFF;
      font-size: 16px;
      font-weight: bold;
      text-align: center;
    }
  }
}
</style>
